import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { queryClient } from './query-client';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  context: { queryClient },
  // Red de seguridad global: cualquier error de un `beforeLoad`/`loader` (ej.
  // un 504 transitorio de Supabase Auth en el guard de `_app`) se renderiza
  // como un estado de error con reintento, en vez de dejar la pantalla en
  // blanco sin recuperacion. Ver issue #182.
  defaultErrorComponent: RouteErrorBoundary,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export type RouterContext = { queryClient: QueryClient };
